export const KURLY_MALL_CONFIG = ['kurlyMall', 'config'];
